import { createReducer } from "@reduxjs/toolkit";
import type { ContractInitializationState } from "@academy-context/write/application/use-cases/external-provider/subcontracting-contract-enable/enable-subcontracting-contract-reducer";
import { initializeEnrollmentContract, resetInitializeEnrollmentContract } from "./initialize-enrollment-contract";

const initialState: ContractInitializationState = { processing: "idle", signatureLink: null };

export const initializeEnrollmentContractReducer = createReducer<ContractInitializationState>(initialState, builder => {
  builder
    .addCase(initializeEnrollmentContract.fulfilled, (state, action) => {
      return {
        ...state,
        processing: "success",
        signatureLink: action.payload,
      };
    })
    .addCase(initializeEnrollmentContract.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(initializeEnrollmentContract.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetInitializeEnrollmentContract, () => {
    return initialState;
  });
});
